import { render, staticRenderFns } from "./PostTestimonial.vue?vue&type=template&id=740fbc71&"
import script from "./PostTestimonial.vue?vue&type=script&lang=js&"
export * from "./PostTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports